import { useTranslation } from "react-i18next"
import { getFormattedDate } from "./get-formatted-date"

export function useGetFormattedDatePeriod() {
  const { t } = useTranslation("app_server")
  return (start: string | null | undefined, end: string | null | undefined) => {
    let res = ""
    if (start) {
      if (!end) {
        res += `${t("From_LowerCase")} `
      }
      res += getFormattedDate(start)
    }
    if (end) {
      if (!start) {
        res += `${t("To_LowerCase")} `
      }
      res += (start ? " - " : "") + getFormattedDate(end)
    }
    return res
  }
}
